import {
    Box,
    Grid,
    GridItem,
    Heading,
    IconButton,
    Spinner,
    TabPanels,
    Tabs,
    Text,
    useToast
} from '@chakra-ui/react'
import { Icon } from 'components/atoms/Icon'
import { useInstitutionsContext } from 'contexts/institutions'
import { InstitutionDomain } from 'domains/InstitutionDomain'
import { motion } from 'framer-motion'
import { ErrorResponseDTO, InstitutionsResponseDTO } from 'models'
import React, { useEffect, useState } from 'react'
import { Link as LinkRouter, useNavigate, useParams } from 'react-router-dom'
import formatter from 'utils/formatter'
import Address from './components/Address'
import Agent from './components/Agent'
import { Attachments } from './components/Attachments'
import Data from './components/Data'
import Responsible from './components/Responsible'
import { TabCustom, TabListCustom, TabPanelCustom, TabTitle } from './styles'
import { errosInstitution } from './utils/errosInstitution'

const Institution: React.FC = () => {
    const { getInstitution } = useInstitutionsContext()
    const [institution, setInstitution] = useState<InstitutionsResponseDTO>()

    const toast = useToast()

    const { id = '' } = useParams()
    const navigate = useNavigate()

    const fetchInstitution = async (loadPage = false) => {
        try {
            const { data } = await getInstitution(id)

            if (!loadPage) {
                const institutionDomain = new InstitutionDomain()
                institutionDomain.resetCache()
            }
            setInstitution(data)
        } catch (error: any) {
            const { data } = error.response as ErrorResponseDTO

            data.filter(
                (elem, index, arr) =>
                    index ===
                    arr.findIndex(checkEle => checkEle.codigo === elem.codigo)
            ).map(res => {
                const error = errosInstitution[res.codigo]

                toast({
                    title: error.title,
                    description: error.description,
                    position: 'bottom-left',
                    status: 'error',
                    isClosable: true,
                    variant: 'solid-error'
                })
            })

            navigate('/instituicoes')
        }
    }

    useEffect(() => {
        const loadPage = true
        fetchInstitution(loadPage)
    }, [])

    return (
        <>
            <Tabs
                isLazy
                data-testid="institution-tabs"
                colorScheme="primary"
                as={motion.div}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <TabListCustom data-testid="institution-tab-list">
                    <TabCustom data-testid="institution-tab-item-view">
                        Visualizar
                    </TabCustom>
                    <TabCustom data-testid="institution-tab-address">
                        Endereços
                    </TabCustom>
                    <TabCustom data-testid="institution-tab-responsible">
                        Responsáveis legais
                    </TabCustom>
                    <TabCustom data-testid="institution-tab-agent">
                        Agentes Financeiros
                    </TabCustom>
                    <TabCustom data-testid="institution-tab-agent">
                        Anexos
                    </TabCustom>
                </TabListCustom>
                <TabTitle pt={4} data-testid="institution-tab-title">
                    {institution && (
                        <Grid
                            templateColumns={{ md: 'repeat(3, auto)' }}
                            justifyContent="space-between"
                            alignItems="center"
                            gap={{ base: 4, md: 6 }}
                            px={6}
                            py={4}
                        >
                            <GridItem w="100%">
                                <Box display="flex" gap={4} alignItems="center">
                                    <IconButton
                                        data-testid="institution-tab-back"
                                        as={LinkRouter}
                                        to="/instituicoes"
                                        colorScheme="transparent"
                                        color="inherit"
                                        aria-label="edit"
                                        icon={<Icon name="arrow-left" />}
                                    />
                                    <Heading
                                        data-testid="institution-tab-heading"
                                        size="md"
                                        w="100%"
                                    >
                                        {institution?.razaoSocial}
                                    </Heading>
                                </Box>
                            </GridItem>
                            <GridItem w="100%">
                                <Box
                                    display="flex"
                                    gap={4}
                                    alignItems="center"
                                    data-testid="institution-tab-updated"
                                >
                                    <Text fontWeight="bold">
                                        Última atualização:
                                    </Text>
                                    {institution &&
                                        formatter.data(
                                            institution.dataAlteracao || ''
                                        )}
                                </Box>
                            </GridItem>
                        </Grid>
                    )}
                </TabTitle>
                {institution ? (
                    <TabPanels data-testid="institution-tab-panels">
                        <TabPanelCustom data-testid="institution-tab-panel-data">
                            <Data
                                initial={institution}
                                fetchInstitution={fetchInstitution}
                            />
                        </TabPanelCustom>
                        <TabPanelCustom data-testid="institution-tab-panel-address">
                            <Address
                                initial={institution}
                                fetchInstitution={fetchInstitution}
                            />
                        </TabPanelCustom>
                        <TabPanelCustom data-testid="institution-tab-panel-responsible">
                            <Responsible
                                initial={institution}
                                fetchInstitution={fetchInstitution}
                            />
                        </TabPanelCustom>
                        <TabPanelCustom data-testid="institution-tab-panel-agent">
                            <Agent />
                        </TabPanelCustom>
                        <TabPanelCustom data-testid="institution-tab-panel-agent">
                            <Attachments initial={institution} />
                        </TabPanelCustom>
                    </TabPanels>
                ) : (
                    <Box
                        display="flex"
                        as={motion.div}
                        bg="white"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        height="100%"
                        justifyContent="center"
                        pb="36px"
                    >
                        <Spinner
                            bg="white"
                            size="xl"
                            speed="1s"
                            left="calc(50% - 33px)"
                        />
                    </Box>
                )}
            </Tabs>
        </>
    )
}

export default Institution
